import { toast } from 'react-toastify';
import { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import validator from 'validator';

export default function Register({setCurrentUser}) {

  const [email, setEmail] = useState("");
	const navigate = useNavigate ();

  // email
  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  }

  useEffect(() => {
    async function checkEmail() {
      if (validator.isEmail(email)) {
        document.getElementById('btn_submit').disabled = false;
      }
      else {
        document.getElementById('btn_submit').disabled = true;
      }
    }

    // Check Word
    checkEmail();
  }, [email]);

  const handleSubmit = (e) => {
    // Prevent the browser from reloading the page
    e.preventDefault();

    // Get the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = JSON.stringify(Object.fromEntries(formData.entries()));

    if (validator.isEmail(form.email.value)) {
      // Send to API
      getPassword(formJson);
    }
    else {
      toast.error('L\'email est invalide, veuillez le modifier.', {
        autoClose: 2000,
      });
    }
  }

  // Get temp password
  async function getPassword(data) {
    await fetch(process.env.REACT_APP_API_SERVER + '/lostpwd', { 
      method: 'post', 
      headers: {'Content-Type': 'application/json'},
      body: data 
    })
    .then(response => response.json())
    .then(data => confirmation(data));
    return;
  }

  // Display confirmation message
  const confirmation = (data) => {
    console.log(data);
    if (data.status === 'success') {
      toast.success('Changement de mot de passe réussi 🎉', {
        autoClose: 1000,
        onClose: () => {
          navigate('/');
        }
      });
    }
    else {
			toast.error("Erreur de modification du mot de passe 😱", {
        autoClose: 1000
      });
      console.log("Erreur de changement de mot de passe");
    }
  }
    
	return(
		<>
      <p>Saisissez votre email pour recevoir un mot de passe temporaire</p>

			<form method="post" onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="email">Email : </label>
          <input type="text" name="email" value={email} onChange={e => handleChangeEmail(e)} />
        </div>

        <div className="field">
          <input type="submit" id="btn_submit" disabled value="Valider" />
        </div>
			</form>
		</>
	);
}